module.exports = __webpack_public_path__ + "static/media/Group47.8440aeb8.svg";